import React from "react";

const Heroes = () => {
    return (
      <React.Fragment>
          <div>Heroes</div>
      </React.Fragment>
    );
  };
  
  export default Heroes;